import normalize from "json-api-normalizer";
import merge from "lodash/merge";
import moment from "moment";

import { GET } from "../../../../../../util/apiHelpers";
import { mergeWithArrayOverwrite } from "../../../../../../util/formatHelpers";
import { PERCENTAGE_OF_COMPENSATION } from "../../../../../forms/formik/FormikFeeOptions/fieldHelpers";

export const RECRUITIFI_COMMUNITY = "RecruitiFi Community";

export const COMMUNITY_AGENCY_ATTRIBUTES = {
  id: RECRUITIFI_COMMUNITY,
  individual: {
    id: RECRUITIFI_COMMUNITY,
    attributes: {
      id: RECRUITIFI_COMMUNITY,
      activatedAt: moment().toString(),
      firstName: "Targeted",
      lastName: "Experts",
      name: "Targeted Experts",
      rating: "4.7",
      roles: [],
      levels: [],
      regions: [],
      organizationId: RECRUITIFI_COMMUNITY,
    },
  },
  organization: {
    id: RECRUITIFI_COMMUNITY,
    attributes: {
      id: RECRUITIFI_COMMUNITY,
      name: RECRUITIFI_COMMUNITY,
    },
  },
  preferredLink: {
    id: RECRUITIFI_COMMUNITY,
    attributes: {
      fee: "20%",
      permEnabled: true,
      tempEnabled: true,
      optmizedFee: true,
      tempOptimizedFee: false,
      feeOptions: [{ feePercentage: 0.2, feeType: PERCENTAGE_OF_COMPENSATION }],
    },
  },
  description:
    "A group of vetted agencies matched by RecruitiFi to this JobCast",
  listDescription: "A group of vetted agencies matched by RecruitiFi",
};

export async function loadCommunityData(country, organization_name, isTemp) {
  const baseUrl = isTemp
    ? "/api/v3/public/temp_community_terms/"
    : "/api/v3/public/community_terms/";

  const updateData = await GET(baseUrl + encodeURI(country))
    .then((res) => {
      const normalized = normalize(res.data);

      const { attributes } =
        normalized.tempCommunityTerms[
          Object.keys(normalized.tempCommunityTerms)[0]
        ];

      const feeOptionAttr = isTemp ? "conversionFeeOption" : "feeOption";
      const feeOptionsAttr = isTemp ? "conversionFeeOptions" : "feeOptions";
      const { feePercentage } = attributes[feeOptionAttr];

      const fee = `${(feePercentage * 100).toFixed(1)}%`;
      return {
        preferredLink: {
          attributes: {
            fee,
            feeType: PERCENTAGE_OF_COMPENSATION,
            feeOptions: attributes[feeOptionsAttr],
          },
        },
      };
    })
    .catch(() => ({
      preferredLink: {
        attributes: { fee: "20%", feeType: PERCENTAGE_OF_COMPENSATION },
      },
    }));

  if (organization_name) {
    merge(updateData, {
      organization: {
        attributes: { name: `${organization_name}'s Community` },
      },
    });
  }

  return mergeWithArrayOverwrite({}, COMMUNITY_AGENCY_ATTRIBUTES, updateData);
}
